<template>
  <el-table
    :data="seeds"
    :row-class-name="tableRowClassName"
  >
    <el-table-column
      label="Event (Carrier)"
      prop="event"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Description (Carrier)"
      prop="description"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue || '-') : '-'"
    />

    <el-table-column
      label="Level (OpenFreight)"
      prop="level"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
    />

    <el-table-column
      label="Level Type (OpenFreight)"
      prop="level.type"
      sortable
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? (cellValue.name || '-') : '-'"
    />

    <el-table-column
      v-if="canUpdate"
      label="Actions"
      align="right"
      width="120"
    >
      <template slot-scope="scope">
        <el-button
          size="mini"
          @click.native="$emit('edit', scope.row)"
        >
          Edit
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<style>
  .el-table .warning-row {
    background: #fdf6ec;
  }

  .el-table .error-row {
    background: rgba(246, 152, 152, 0.61);
  }
</style>

<script>
import { UPDATE } from '@/plugins/user'

export default {
  props: {
    seeds: {
      type: Array,
      required: true
    }
  },
  computed: {
    canUpdate () {
      return this.$user.can(UPDATE, 'tracking.seed') || true
    }
  },
  methods: {
    tableRowClassName ({ row }) {
      if (!row.level) {
        return 'error-row'
      } else if (row.level.type.name === 'Error') {
        return 'warning-row'
      }
      return ''
    }
  }
}
</script>
